export const CLUB_MAP_TILE_PROVIDERS = {
  cartoVoyager: {
    name: "CARTO Voyager",
    url: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  },
  cartoPositron: {
    name: "CARTO Positron",
    url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  },
  cartoDarkMatter: {
    name: "CARTO Dark Matter",
    url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  },
  stadiaAlidadeSmoothDark: {
    name: "Stadia Maps - Alidade Smooth Dark",
    url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
    attribution:
      '&copy; <a href="https://www.stadiamaps.com/">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  },
  openStreetMap: {
    name: "OpenStreetMap",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  },
} as const;

export type ClubMapTileProviderKey = keyof typeof CLUB_MAP_TILE_PROVIDERS;

const DEFAULT_TILE_PROVIDER_KEY: ClubMapTileProviderKey = "openStreetMap";

export function getConfiguredClubMapTileProviderKey(): ClubMapTileProviderKey {
  const configuredProvider = process.env
    .REACT_APP_TNP_CLUBS_MAP_PROVIDER as ClubMapTileProviderKey;

  if (configuredProvider && CLUB_MAP_TILE_PROVIDERS[configuredProvider]) {
    return configuredProvider;
  }

  return DEFAULT_TILE_PROVIDER_KEY;
}

export function buildClubMapTileProviderOrder(
  preferredProviderKey = getConfiguredClubMapTileProviderKey(),
) {
  return [
    preferredProviderKey,
    "openStreetMap",
    "cartoPositron",
    "cartoVoyager",
  ].filter(
    (providerKey, index, providers) => providers.indexOf(providerKey) === index,
  ) as ClubMapTileProviderKey[];
}
